const fullDateFormatWithoutYear = (date: string) => date.substring(0, date.length - 3);

export default fullDateFormatWithoutYear;